import React from 'react';
import Img from 'gatsby-image/withIEPolyfill';
import { breakpoints, mediaQueries } from '@everlywell/leaves';

import useMediaQuery from 'utils/useMediaQuery';
import { FluidImageType } from 'utils/types';

export type BackgroundImageProps = {
  fluidImage: FluidImageType;
  mobileFluidImage?: FluidImageType;
  verticalCenter?: boolean;
  alt?: string;
};

/**
 * Background Image component for the hero section - uses gatsby-image and srcSets
 * to efficiently render the hero image
 */
export const BackgroundImage: React.FC<BackgroundImageProps> = ({
  fluidImage,
  mobileFluidImage,
  verticalCenter,
  alt,
}) => {
  let sources = [fluidImage];

  if (mobileFluidImage) {
    sources = [
      mobileFluidImage,
      {
        ...fluidImage,
        media: `(min-width: ${breakpoints.forTabletVerticalUp}px)`,
      },
    ];
  }

  // position the image for desktop up
  const isDesktop = useMediaQuery(mediaQueries.forDesktopUp);

  return (
    <Img
      fluid={sources}
      loading="eager"
      className="heroBackgroundImage"
      alt={alt || 'hero background image'}
      style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
      }}
      objectPosition={
        isDesktop && verticalCenter ? 'center 20%' : 'center center'
      }
    />
  );
};

export default BackgroundImage;
